/**
 *
 * ComplaintBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import ErrorIcon from '../../../../assets/v2/ErrorIcon';
import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.redDark};
    background: ${COLORS.redLight};
    border-color: ${COLORS.red};
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.red};
    }
  }
`;

function ComplaintBadge(props) {
  return (
    <StyledBadge
      icon={<ErrorIcon />}
      size="iconLarge"
      variant="outlined"
      {...props}
    />
  );
}

export default memo(ComplaintBadge);
